import React from 'react';
import '../../styles/components.css';

const Loading = ({ size = 'medium', fullScreen = false }) => {
  const sizeClass = {
    small: 'spinner-small',
    medium: 'spinner-medium',
    large: 'spinner-large'
  }[size];

  const spinner = (
    <div className={`spinner ${sizeClass}`}>
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Cargando...</span>
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="loading-fullscreen">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default Loading;

// Made with Bob
